// Manufacturer logos and their category mapping
// Corrected mapping based on Word document specifications
// Logos sourced from official brand resources and trusted CDN services

export const manufacturerLogos = {
  ajusa: {
    name: 'Ajusa',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/rljg7das_ajusa.jpg',
    categories: ['engine']
  },
  arnott: {
    name: 'Arnott',
    logo: 'https://customer-assets.emergentagent.com/job_autoparts-landing/artifacts/e5clo66c_arnott.png',
    categories: ['chassis']
  },
  as: {
    name: 'AS',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/9l3a6r1c_as.png',
    categories: ['electrical']
  },
  ate: {
    name: 'ATE',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/q5irozu4_ate_bremsen.png',
    categories: ['brakes']
  },
  beru: {
    name: 'Beru',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/047qc79e_beru-logo.png',
    categories: ['electrical']
  },
  bhsens: {
    name: 'BH SENS',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/wy1kuz1m_bhsens.png',
    categories: ['others']
  },
  bilstein: {
    name: 'Bilstein',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/wts47xii_BILSTEIN_Logo.png',
    categories: ['chassis']
  },
  blueprint: {
    name: 'Blue Print',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/jk06mvt5_blueprint.svg',
    categories: ['brakes', 'chassis', 'clutch']
  },
  borgwarner: {
    name: 'BorgWarner',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/rfw0h2e5_BorgWarner_logo.svg.png',
    categories: ['electrical', 'exhaust']
  },
  bosal: {
    name: 'BOSAL',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/9znxe8og_bosal-logo-1.svg',
    categories: ['exhaust']
  },
  bosch: {
    name: 'BOSCH',
    logo: 'https://customer-assets.emergentagent.com/job_autoparts-landing/artifacts/20nw9kab_bosch.png',
    categories: ['filters', 'electrical', 'brakes', 'others']
  },
  brembo: {
    name: 'Brembo',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/1ufmju4w_brembo.png',
    categories: ['brakes']
  },
  budweg: {
    name: 'Budweg Caliper',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/fz2f1i9c_budweg_nav.png',
    categories: ['brakes']
  },
  bugiad: {
    name: 'Bugiad',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/ywca3399_bugiad.png',
    categories: ['others']
  },
  castrol: {
    name: 'Castrol',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/nqo3s053_castrol-horizontal-logo.avif',
    categories: ['filters']
  },
  continental: {
    name: 'Continental',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/kywpcc4l_Continental-Logo.svg.png',
    categories: ['engine']
  },
  corteco: {
    name: 'Corteco',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/wjyszxie_corteco.jpg',
    categories: ['engine']
  },
  dayco: {
    name: 'Dayco',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/7igwz74n_dayco.jpg',
    categories: ['engine']
  },
  denso: {
    name: 'Denso',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/a8bum1ow_denso.png',
    categories: ['climate']
  },
  diedrichs: {
    name: 'Diedrichs',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/y1uahnxy_diedrichs.jpg',
    categories: ['body']
  },
  elf: {
    name: 'ELF',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/k82hn6fu_elf.png',
    categories: ['filters']
  },
  eurolube: {
    name: 'Eurolube',
    logo: 'https://customer-assets.emergentagent.com/job_autoparts-landing/artifacts/tyekjvsh_EUROLUB-logo.webp',
    categories: ['filters']
  },
  elring: {
    name: 'Elring',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/azvzewyj_elring.svg',
    categories: ['engine']
  },
  era: {
    name: 'ERA',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/5x65m497_era.png',
    categories: ['electrical', 'climate']
  },
  ernst: {
    name: 'ERNST',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/xfgq4iey_ernst-vector-logo.png',
    categories: ['exhaust']
  },
  fag: {
    name: 'FAG',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/ntrvxiwu_FAG_logo.svg.png',
    categories: ['chassis']
  },
  febi: {
    name: 'Febi',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/jummigwh_febi.svg',
    categories: ['chassis', 'electrical', 'engine']
  },
  gkn: {
    name: 'GKN',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/r95s7vld_GKN_Logo.svg.png',
    categories: ['drivetrain', 'others']
  },
  hella: {
    name: 'HELLA',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/rneyanfg_hella.png',
    categories: ['electrical', 'lighting']
  },
  herthbuss: {
    name: 'Herth+Buss',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/6qobrmvl_herthbuss.jpg',
    categories: ['electrical', 'brakes']
  },
  imasaf: {
    name: 'Imasaf',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/k7gc3093_imasaf.png',
    categories: ['exhaust']
  },
  ina: {
    name: 'INA',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/u1v6id4c_INA_logo.svg.png',
    categories: ['engine']
  },
  iwis: {
    name: 'IWIS',
    logo: 'https://customer-assets.emergentagent.com/job_autoparts-landing/artifacts/bzin0cym_iwis%20Logo.jpg',
    categories: ['engine']
  },
  japanparts: {
    name: 'Japanparts',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/8bz0n8mv_japanparts_logo.png',
    categories: ['chassis', 'engine', 'clutch', 'others']
  },
  kolbenschmidt: {
    name: 'Kolbenschmidt',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/siyo6g76_kolbenschmidt.jpg',
    categories: ['engine']
  },
  kyb: {
    name: 'KYB',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/11xtzx4p_KYB-LOGO_NoStrapline-1.png',
    categories: ['chassis']
  },
  lemforder: {
    name: 'Lemförder',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/0jida6im_lemfoerder-logo-cmyk.png',
    categories: ['chassis']
  },
  lesjofors: {
    name: 'Lesjöfors',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/cel6y66i_lesjofors-logo-without-payoff.jpg',
    categories: ['chassis']
  },
  liquimoly: {
    name: 'Liqui Moly',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/f4abb5ma_Liqui-moly.svg.png',
    categories: ['filters', 'others']
  },
  lobro: {
    name: 'Löbro',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/ze5gzkw2_gkn%20spidan%20loebro.jpg',
    categories: ['others']
  },
  luk: {
    name: 'LUK',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/fbagojwz_LuK_logo.svg',
    categories: ['clutch', 'others']
  },
  magnetimarelli: {
    name: 'Magneti Marelli',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/qh4md0p9_magnetimarelli.svg',
    categories: ['electrical', 'drivetrain', 'others']
  },
  mahle: {
    name: 'MAHLE',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/ts4h1wbn_Mahle_%28Unternehmen%29_2020_logo.svg',
    categories: ['filters', 'engine', 'climate']
  },
  mannfilter: {
    name: 'MANN-FILTER',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/zqxdg46p_mann%20filter.webp',
    categories: ['filters']
  },
  maxgear: {
    name: 'Maxgear',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/5jwcas4n_maxgear-logo.png',
    categories: ['chassis', 'brakes']
  },
  metzger: {
    name: 'Metzger',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/ieqsge0r_Metzger-Autoteile-4C.avif',
    categories: ['engine', 'electrical']
  },
  meyle: {
    name: 'Meyle',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/1d7osskx_meyle.jpg',
    categories: ['chassis', 'brakes', 'others']
  },
  mobil: {
    name: 'Mobil',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/ml451l30_Mobil_logo.svg.png',
    categories: ['filters']
  },
  motul: {
    name: 'Motul',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/n0y7rudr_Motul_logo.svg.png',
    categories: ['filters']
  },
  narva: {
    name: 'Narva',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/pxf4d6q2_narva.jpg',
    categories: ['lighting']
  },
  ngk: {
    name: 'NGK',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/v1l54rxt_Ngk_logo_rund.svg',
    categories: ['electrical']
  },
  nissens: {
    name: 'Nissens',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/kv0pruej_nissens-logo-2024.jpg',
    categories: ['engine', 'climate']
  },
  nk: {
    name: 'NK',
    logo: 'https://customer-assets.emergentagent.com/job_autoparts-landing/artifacts/qsgxbcma_NK%20Logo.png',
    categories: ['chassis']
  },
  nrf: {
    name: 'NRF',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/e05euxnv_NRF_LOGO_PNG.png',
    categories: ['climate']
  },
  ntk: {
    name: 'NTK',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/fxolueg9_ntk.png',
    categories: ['electrical']
  },
  optimal: {
    name: 'Optimal',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/v0rrc3z9_optimal.png',
    categories: ['chassis', 'brakes']
  },
  osram: {
    name: 'OSRAM',
    logo: 'https://customer-assets.emergentagent.com/job_autoparts-landing/artifacts/qu93eoe5_osram-vector-logo.png',
    categories: ['lighting']
  },
  philips: {
    name: 'Philips',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Philips_logo_new.svg/320px-Philips_logo_new.svg.png',
    categories: ['lighting']
  },
  pierburg: {
    name: 'Pierburg',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/q0sivwaj_pierburg.jpg',
    categories: ['engine', 'electrical']
  },
  prasco: {
    name: 'PRASCO',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/ye97eaiq_PRASCO.webp',
    categories: ['body']
  },
  quaro: {
    name: 'Quaro',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/ir2vuf35_quaro.png',
    categories: ['brakes', 'chassis']
  },
  ravenol: {
    name: 'Ravenol',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/8co8lpas_RAVENOL_Logo.jpg',
    categories: ['filters']
  },
  sachs: {
    name: 'Sachs',
    logo: 'https://customer-assets.emergentagent.com/job_autoparts-landing/artifacts/3hhkit31_sachs%20Logo%20neu1.png',
    categories: ['chassis', 'clutch']
  },
  shell: {
    name: 'Shell',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/fwdo765z_shell.png',
    categories: ['filters']
  },
  sonax: {
    name: 'Sonax',
    logo: 'https://customer-assets.emergentagent.com/job_autoparts-landing/artifacts/2rzlocsi_Sonax_logo.svg.png',
    categories: ['others']
  },
  skf: {
    name: 'SKF',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/b3lvhhfa_skf.png',
    categories: ['engine', 'chassis', 'drivetrain']
  },
  spidan: {
    name: 'Spidan',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/w0g2l6fu_image.png',
    categories: ['drivetrain', 'others']
  },
  stabilus: {
    name: 'Stabilus',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/s3qvv2j8_Stabilus_logo.svg.png',
    categories: ['others']
  },
  swf: {
    name: 'SWF',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/f1b5ik8m_swf.gif',
    categories: ['others']
  },
  textar: {
    name: 'Textar',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/p58g1x9s_textar.webp',
    categories: ['brakes']
  },
  total: {
    name: 'Total',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/6aemi053_Total_Logo.svg',
    categories: ['filters']
  },
  trw: {
    name: 'TRW',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/arzw0rvf_TRW_logo.svg.png',
    categories: ['brakes']
  },
  triscan: {
    name: 'Triscan',
    logo: 'https://customer-assets.emergentagent.com/job_7c9c200c-91a8-481c-82f7-30f6f659281a/artifacts/lf6ngzoj_triscan.jpeg',
    categories: ['drivetrain']
  },
  valeo: {
    name: 'Valeo',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/bn11b1rn_Valeo_Logo.svg.png',
    categories: ['clutch', 'electrical', 'lighting', 'climate']
  },
  vanwezel: {
    name: 'Van Wezel',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/nzvtu4bz_van_wezel.jpg',
    categories: ['body', 'lighting', 'climate']
  },
  varta: {
    name: 'Varta',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/ttz6vbmd_Varta-Logo.svg.png',
    categories: ['electrical']
  },
  victorreinz: {
    name: 'Victor Reinz',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/qsgebao0_victor-reinz.png',
    categories: ['engine']
  },
  zf: {
    name: 'ZF',
    logo: 'https://customer-assets.emergentagent.com/job_auto-parts-consult/artifacts/uw2hfztf_ZF_logo_STD_Blue_3CC.svg',
    categories: ['filters']
  }
};

// Get manufacturers by category
export const getManufacturersByCategory = (categoryId) => {
  return Object.values(manufacturerLogos).filter(manufacturer => 
    manufacturer.categories.includes(categoryId)
  );
};

// Category ID mapping
export const categoryMapping = {
  brakes: 'brakes',
  filters: 'filters',
  chassis: 'chassis',
  electrical: 'electrical',
  lighting: 'lighting',
  exhaust: 'exhaust',
  clutch: 'clutch',
  engine: 'engine',
  body: 'body',
  drivetrain: 'drivetrain',
  climate: 'climate',
  others: 'others'
};
